module.exports = __webpack_public_path__ + "static/media/icon-sap.3beee50f.svg";